import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'
import { ordersStatsKey } from '@/pages/Home/homeReads'

export interface RecordSettings {
  first_quote_target_minutes: number
  /** Kept in the Business Profile's key on the server; 0 turns the reminder off (SA-1217). */
  quote_decision_reminder_minutes: number
}

const PATH = '/api/admin/record-settings'

export const recordSettingsKey = ['record-settings'] as const

export function useRecordSettings() {
  return useQuery<RecordSettings, Error>({
    queryKey: recordSettingsKey,
    queryFn: () => apiClient.get<RecordSettings>(PATH),
    retry: false,
  })
}

export function useSaveRecordSettings() {
  const qc = useQueryClient()
  return useMutation<RecordSettings, Error, RecordSettings>({
    mutationFn: (write) => apiClient.put<RecordSettings>(PATH, write),
    onSuccess: (data) => {
      qc.setQueryData(recordSettingsKey, data)
      // the stats read carries the target the Home tile judges against
      qc.invalidateQueries({ queryKey: ordersStatsKey })
    },
  })
}
